var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('RegisterHeader'),_c('RegisterIntro'),_c('RegisterBullets'),_c('RegisterHow'),_c('RegisterPricing'),_c('RegisterMore')],1)}
var staticRenderFns = []

export { render, staticRenderFns }